
  import { Component, Mixins } from 'vue-property-decorator';

  import Dropdown from '@/mixins/common/dropdown';

  @Component
  export default class PendingInfo extends Mixins<Dropdown>(Dropdown) {}
